import { Link } from 'react-router-dom';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

// Public intro video (no login). The file lives in the assets bucket under
// public/hallo/ so frontend deploys (s3 sync --delete) don't remove it.
const VIDEO_URL = 'https://assets.symbolbuch.de/public/hallo/symbolbuch-vorstellung.mp4';

export function HalloPage() {
  useDocumentTitle('Kurz vorgestellt');

  return (
    <div className="min-h-dvh bg-[#fbfaf8] flex flex-col">
      <header className="max-w-5xl w-full mx-auto px-4 pt-8 pb-4 flex items-center gap-3">
        <img src="/icon-192.png" alt="" className="w-10 h-10 rounded-xl" />
        <span className="text-2xl font-bold text-gray-900 tracking-tight">
          Symbolbuch<span className="text-indigo-600">.de</span>
        </span>
      </header>

      <main className="max-w-5xl w-full mx-auto px-4 pb-12 flex-1">
        <h1 className="sr-only">Symbolbuch.de – kurz vorgestellt</h1>

        <div className="mt-4 rounded-2xl overflow-hidden shadow-xl border border-gray-200 bg-white aspect-video">
          <video
            className="w-full h-full block"
            src={VIDEO_URL}
            poster="/hallo-poster.jpg"
            controls
            playsInline
            preload="metadata"
            controlsList="nodownload noplaybackrate noremoteplayback"
            disablePictureInPicture
            onContextMenu={(e) => e.preventDefault()}
          >
            Dein Browser kann dieses Video leider nicht abspielen.
          </video>
        </div>

        <section className="mt-10 grid gap-4 sm:grid-cols-2">
          <div className="rounded-2xl border border-gray-200 bg-white p-6">
            <h2 className="text-lg font-semibold text-gray-900">Interesse?</h2>
            <p className="text-gray-600 mt-2 leading-relaxed">
              Symbolbuch.de ist ein geschlossenes System – den Zugang gibt es auf Einladung. Schreibt uns einfach:
            </p>
            <a href="mailto:kontakt@symbolbuch.de" className="inline-block mt-3 text-indigo-600 font-medium hover:underline">
              kontakt@symbolbuch.de
            </a>
          </div>
          <div className="rounded-2xl border border-gray-200 bg-white p-6">
            <h2 className="text-lg font-semibold text-gray-900">Hast du schon einen Zugang?</h2>
            <p className="text-gray-600 mt-2 leading-relaxed">Dann direkt anmelden und loslegen.</p>
            <Link
              to="/login"
              className="inline-block mt-3 px-5 py-2.5 rounded-xl bg-indigo-600 text-white font-medium hover:bg-indigo-700"
            >
              Zur Anmeldung
            </Link>
          </div>
        </section>
      </main>

      <footer className="max-w-5xl w-full mx-auto px-4 py-6 text-sm text-gray-500 flex gap-4">
        <Link to="/impressum" className="hover:text-gray-700">Impressum</Link>
        <Link to="/impressum#datenschutz" className="hover:text-gray-700">Datenschutz</Link>
      </footer>
    </div>
  );
}
